import React from 'react';
import {browserHistory} from 'react-router';

class Link extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    browserHistory.push(this.props.url);
  }

  render() {
    let {className, url} = this.props;
    return (
      <a className={className ? className : null} href={url} onClick={this.handleClick}>
        {this.props.children}
      </a>
    );
  }

}

Link.propTypes = {
  url: React.PropTypes.string.isRequired,
  className: React.PropTypes.string,
  children: React.PropTypes.node
};

export default Link;



/** WEBPACK FOOTER **
 ** ./src/modules/routing/components/Link.js
 **/